import styled, { css } from 'styled-components';
import {
  AccordionItem,
  Badge,
  Divider,
  H3,
  paletteHelper,
  spacingHelper,
  Text,
  typographyHelper,
  radiusHelper,
  mediaHelper,
  boxShadow,
} from '@property.com.au/ui-kit';

export const StyledSchoolAccordionItem = styled(AccordionItem)<{ $isZoned: boolean }>`
  border: none;
  border-radius: ${radiusHelper('medium')};
  ${boxShadow.defaultBoxShadow};
  margin-bottom: ${spacingHelper('extraSmall')};

  .headerButton {
    border-radius: ${radiusHelper('medium')};
    /* override rules so that button color doesn't change on hover */
    &:hover {
      background-color: initial;
    }
    :focus-visible {
      background-color: transparent;
      outline: solid calc(${spacingHelper('twoExtraSmall')} / 2);
    }
  }
  .content {
    padding-top: 0;
  }

  background-color: ${(props) =>
    props.$isZoned
      ? paletteHelper('backgroundBlueSecondary')
      : paletteHelper('backgroundPrimaryHigh')};

  &:last-of-type {
    /* override accordion rule that last item has a bottom border */
    border-bottom: none;
  }
`;

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const schoolNameWidth = 206;

export const SchoolName = styled(H3)`
  ${typographyHelper('body02Bold')};
  ${mediaHelper('tabletMin')} {
    width: ${schoolNameWidth}px;
  }
`;

export const sharedZonedCss = css`
  flex-grow: 0;
  display: inline;
  text-align: center;
`;

export const ZonedBadge = styled(Badge).attrs({ variant: 'blue' })`
  ${sharedZonedCss};
  margin-left: ${spacingHelper('twoExtraSmall')};
`;

export const ZonedBadgePlaceholder = styled.div`
  ${sharedZonedCss};
`;

export const SchoolFactsTable = styled.div`
  ${mediaHelper('desktopMin')} {
    display: none;
  }
  margin-bottom: ${spacingHelper('medium')};
`;

export const StyledDivider = styled(Divider)`
  margin: ${spacingHelper('extraSmall')} 0;
  border-color: ${paletteHelper('borderPrimary')};
`;

export const SchoolFactsTitle = styled(Text)<{ $isZoned: boolean }>`
  flex: 1;
  ${typographyHelper('overline')};
  color: ${paletteHelper('textSecondary')};

  ${(props) =>
    props.$isZoned &&
    css`
      & {
        color: ${paletteHelper('textPrimary')};
      }
    `}
`;

export const SchoolFactsSubtitle = styled(Text)<{ $isZoned: boolean }>`
  flex: 1;
  ${typographyHelper('body02')}
  color: ${paletteHelper('textSecondary')};

  ${(props) =>
    props.$isZoned &&
    css`
      & {
        color: ${paletteHelper('textPrimary')};
      }
    `}
`;

export const LinksWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  a {
    margin-top: ${spacingHelper('twoExtraSmall')};
    margin-bottom: ${spacingHelper('twoExtraSmall')};
    &:not(:last-child) {
      margin-right: ${spacingHelper('extraSmall')};
    }
  }
`;

export const rowDisplacementValue = spacingHelper('threeExtraLarge');

export const DesktopSchoolFactsSubtitleWrapper = styled.div`
  ${mediaHelper('tabletMax')} {
    display: none;
  }
  display: flex;
  justify-content: space-between;
  flex-grow: 1;
  margin-left: ${spacingHelper('medium')};

  /* hack to move table over */
  margin-right: -${rowDisplacementValue};
  > :last-child {
    padding-right: ${rowDisplacementValue};
  }
`;

export const DesktopSchoolFactsSubtitle = styled(Text)<{ $isZoned: boolean }>`
  ${typographyHelper('body02')}
  color: ${paletteHelper('textSecondary')};
  width: 25%;

  ${(props) =>
    props.$isZoned &&
    css`
      & {
        color: ${paletteHelper('textPrimary')};
      }
    `}
`;
